<div class="fullcontainer">
  <br />
  <br />
  <div class='titleContainer'>
    <h2 class='header'>Inspections</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/workshop/inspections/calendar'><i class="fas fa-calendar-check"></i> Calendar</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/workshop/inspections/bulk'><i class="fas fa-layer-group"></i> Bulk add</button>&nbsp;
    </div>
  </div>
  <br />
  @if (this.error) { <div class="alert alert-danger">{{ this.error }}</div> }
  <br />
  <app-grid entity='vehicle-inspection' [columns]='this.columns' [buttons]='this.buttons'
    [searchFilters]='this.searchFilters' [searchFields]='this.searchFields' sortColumn='nextDueDate' sortDirection='asc'></app-grid>
  <app-inspection-action-modal [target]='this.target' [mode]='this.mode' (saved)='this.refresh()'></app-inspection-action-modal>
</div>
